import { LawyerLite } from './../../models/lawyers/lawyer';
import { AuthService } from './../../../core/services/auth/auth.service';
import { UserRole } from './../../models/users/user';
import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ServicesApiService } from 'src/app/core/services/api/services-api.service';
import { TimesheetApiService } from 'src/app/core/services/api/timesheet-api.service';
import { NgSelectProps } from '../../models/ng-select-props';
import { Service } from '../../models/services/service';
import { Timesheet } from '../../models/timesheet/timesheet';
import { TimesheetEntry } from '../../models/timesheet/timesheetEntry';
import { OperatorFunction, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';
import { CaseLite } from '../../models/cases/caseLite';
import { CaseSearchResultsLite } from '../../models/cases/caseSearchResults';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { TimesheetSearchParams } from '../../models/timesheet/timesheetSearchParams';
import { TimesheetSearchResults } from '../../models/timesheet/timesheetSearchResults';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-timesheet-entry-form',
  templateUrl: './timesheet-entry-form.component.html',
  styleUrls: ['./timesheet-entry-form.component.scss']
})
export class TimesheetEntryFormComponent implements OnInit {
  timesheets: Timesheet[] = [];
  services: Service[] = [];

  servicesNgSelect = null;
  timesheetsNgSelect = null;
  timesheetsLoading = false;

  @Input() entry: TimesheetEntry;
  @Input() selectedTimesheet: number;
  @Input() fileNum: string;
  @Input() fileLawyers: LawyerLite[] = [];
  @Output() submitEntry: EventEmitter<TimesheetEntry> = new EventEmitter<TimesheetEntry>();
  @Output() close: EventEmitter<any> = new EventEmitter<any>();

  public params: TimesheetSearchParams = new TimesheetSearchParams();
  model: any;
  searching = false;
  searchFailed = false;

  constructor(
    private timesheetApi: TimesheetApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private servicesApi: ServicesApiService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.entry = this.entry ? this.entry : new TimesheetEntry();
  }

  ngOnInit(): void {
    this.servicesNgSelect = new NgSelectProps(this.servicesApi.getTimesheetTasks);
    this.timesheetsNgSelect = new NgSelectProps(this.timesheetApi.getTimesheets);

    if (this.selectedTimesheet) {
      this.entry.timesheet = this.selectedTimesheet;
    }
    if (!this.selectedTimesheet && !this.canEditAnyTimesheet) {
      this.toastr.error('No timesheet context provided!');
    }

  }

  onSubmit(f: NgForm) {
    if (!this.entry.timesheet) {
      this.toastr.error('Please select a file or timesheet first.');
      return;
    }
    this.spinner.show();
    if (this.isAdmin) {
      this.entry.lawyerId = this.entry.lawyer.id;
    }
    this.entry.service = this.entry.serviceData?.id;
    const req = this.entry.id ? this.timesheetApi.updateTimesheetEntry(this.entry) : this.timesheetApi.createTimesheetEntry(this.entry);
    req.subscribe(r => {
      this.toastr.success('Timesheet saved', 'Success!');
      this.spinner.hide();
      this.close.emit();
      if (location.pathname.split('/')[location.pathname.split('/').length - 1] == 'timesheet') {
        location.reload();
      }
    }
    )
  }


  timesheetCreated(form: NgForm) {
    setTimeout(() => {
      form.resetForm();
    }, 500);
  }

  loadTimesheets() {
    if (this.timesheets.length === 0) {
      this.timesheetsLoading = true;
      this.timesheetApi.activeTimesheets().subscribe(r => {
        this.timesheetsLoading = false;
        this.timesheets = r;
        if (r.length === 1 && !this.entry.timesheet) {
          this.entry.timesheet = r[0].id;
        }
      });
    }
  }


  updateServices() {
    const ts = this.timesheets.find(i => i.id === this.entry.timesheet);
    this.services = ts.services;
  }

  trackByFn(item) {
    return item.id;
  }

  onClose() {
    this.close.emit();
  }

  get isAdmin() {
    return this.authService.user.role === UserRole.ADMIN;
  }

  get isAccounting() {
    return this.authService.user.role === UserRole.ACCOUNTING;
  }

  get isLawyer() {
    return this.authService.user.role === UserRole.LAWYER;
  }

  get canEditAnyTimesheet() {
    return this.authService.user.canEditTimesheets;
  }

  searchFn() {
    return true;
  }

  search: OperatorFunction<string, readonly Timesheet[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(term => {
        this.searching = true;
        this.params.search = term;
      }),
      switchMap(term => term === '' ? of(null) :
        this.timesheetApi.getTimesheets(this.params).pipe(
          map((response: TimesheetSearchResults) => {
            this.entry.timesheet = response.results[0]?.id;
          }),
          tap(() => this.searchFailed = false)
        )
      ),
      tap(() => this.searching = false)
    )

  formatter = (x: Timesheet) => x.caseNum;

  handleFile(e) {
    this.entry.timesheet = e.item.id;
  }
}
